module.exports = __webpack_public_path__ + "img/amigo.c95d5765.png";